module.exports = __webpack_public_path__ + "img/page3-2.6d049369.png";